var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input"},[_c('input',{staticClass:"input__field",class:_vm.classes,attrs:{"type":"text","placeholder":_vm.placeholder,"required":_vm.required},domProps:{"value":_vm.value},on:{"input":_vm.updateModel}})])
}
var staticRenderFns = []

export { render, staticRenderFns }